import React from 'react';
import {
  List as AntList,
  Button as AntButton,
  Comment as AntComment,
} from 'antd';
import { LikeOutlined } from '@ant-design/icons';
import moment from 'moment';

import { User } from 'src/slices/auth';
import { Comment } from 'src/slices/comment';
import { useTranslation } from 'react-i18next';
import { GetProfilePicture } from './GetProfilePicture';

interface CommentsListProps {
  comments: Comment[];
  users: { [userId: string]: User };
  likeBtn: (e: any, comment: Comment) => void;
  getBtnType: (comment: Comment) => boolean;
}

export const CommentsList: React.VFC<
  CommentsListProps & React.HTMLAttributes<HTMLDivElement>
> = (props) => {
  const { t } = useTranslation();
  return (
    <AntList
      dataSource={props.comments}
      header={`${props.comments.length} ${
        props.comments.length > 1
          ? t('article.commentPlural')
          : t('article.commentSingular')
      }`}
      itemLayout="horizontal"
      renderItem={(comment) => (
        <AntComment
          actions={[
            <AntButton
              type={props.getBtnType(comment) ? 'primary' : 'default'}
              key={comment._id}
              icon={<LikeOutlined />}
              onClick={(e) => props.likeBtn(e, comment)}
            >
              {t('article.like')} ({comment.likes?.length})
            </AntButton>,
          ]}
          author={
            comment.authorId
              ? `${props.users[comment.authorId]?.firstName} ${
                  props.users[comment.authorId]?.lastName
                }`
              : null
          }
          avatar={
            comment.authorId
              ? props.users[comment.authorId]?.profilePictureUrl
                ? props.users[comment.authorId]?.profilePictureUrl
                : GetProfilePicture(props.users[comment.authorId])
                ? GetProfilePicture(props.users[comment.authorId]).data
                : 'https://joeschmoe.io/api/v1/random'
              : 'https://joeschmoe.io/api/v1/random'
          }
          content={comment.content}
          datetime={moment(comment.createdAt).fromNow()}
        />
      )}
    />
  );
};
